import React from "react";
import { useLoadingStore } from "@store/loaderStore";

const Loader = () => {

    const { loadingMsg } = useLoadingStore();

    return (
        <section className="container loader-container">
            <div className="loader-main">
                {loadingMsg && (
                    <div className="loader-message">
                        {loadingMsg}
                    </div>
                )}
            </div>
        </section>
    )
}

export default Loader;